'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, aid) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      aid: aid

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/adjudicators/' + aid + '/medal-round',
        method: 'GET'
      },
      types: ['GET_MEDAL_ROUND_START', 'GET_MEDAL_ROUND', 'GET_MEDAL_ROUND_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getMedalRound.js
// module id = 642
// module chunks = 0